/* eslint-disable max-len */
export default {
  hello: 'Hallo',

  'center-area-script-name': 'Mein erstes Script',
  'center-area-new-script-name': 'Mein neues Script',
  'center-area-run': 'Script ausführen',
  'center-area-link-card': 'Verknüpfe Oxocard',
  'center-area-upload': 'Bereitstellen',
  'center-area-state-compile': 'Kompiliere',
  'center-area-state-link': 'Verknüpfe',
  'center-area-state-finish': 'Fertig',
  'center-area-button-new': 'Neu',
  'center-area-button-save': 'Speichern',
  'center-area-button-open': 'Öffnen',
  'center-area-button-share': 'Teilen',
  'left-area-toggle-button': 'Menu verkleinern',
  'left-area-button-settings': 'Einstellungen',

  toolbox_button_create_variable: 'Neue Variable',
  toolbox_category_logic: 'Logik',
  toolbox_category_variables: 'Variablen',
  toolbox_category_procedures: 'Funktionen',
  toolbox_category_time: 'Zeit',
  toolbox_category_weather: 'Wetter',
  toolbox_category_oxocard: 'Oxocard',
  toolbox_category_matrix: 'Matrix',
  toolbox_category_communication: 'Kommunikation',
  toolbox_category_accelerometer: 'Beschleunigungssensor',
  toolbox_category_bluetooth: 'Bluetooth',
  toolbox_category_speaker: 'Lautsprecher',
  toolbox_category_microphone: 'Mikrofon',
  toolbox_category_extras: 'Extras',

  toolbox_label_simple: '-------------------------------------------- Einfache Blöcke ---------------------------------------------',
  toolbox_label_advanced: '-------------------------------------- Fortgeschrittene Blöcke ---------------------------------------',
  toolbox_label_expert: '--------------------------------------------- Experten Blöcke ---------------------------------------------',
  toolbox_logic_label_conditions: '------------------------------------------ Bedingungs Blöcke ------------------------------------------',
  toolbox_logic_label_loops: '-------------------------------------------- Schleifen Blöcke ---------------------------------------------',
  toolbox_variables_label_variables: '-------------------------------------------- Variablen Blöcke ---------------------------------------------',
  toolbox_variables_label_calculation_and_allocation: '-------------------------------- Rechen und Zuweisungs Blöcke ---------------------------------',
  toolbox_variables_label_functions: '------------------------------------------- Funktionen Blöcke --------------------------------------------',
  toolbox_variables_label_lists: '---------------------------------------------- Listen Blöcke -------------------------------------------------',
  toolbox_variables_label_pus: '------------------------------- Nichtflüchtiger Speicher Blöcke ----------------------------------',
  toolbox_oxocard_label_on_off: '--------------------------------------------- Ein/Aus Blöcke ----------------------------------------------',
  toolbox_oxocard_label_sensors: '--------------------------------------------- Sensor Blöcke -----------------------------------------------',
  toolbox_oxocard_label_update_mode: '---------------------------------------- Update Mode Blöcke -----------------------------------------',
  toolbox_matrix_label_colors: '--------------------------------------------- Farben Blöcke -----------------------------------------------',
  toolbox_matrix_label_set_pixels: '------------------------------------------ Setze Pixel Blöcke -------------------------------------------',
  toolbox_matrix_label_graphics: '---------------------------------------------- Grafik Blöcke ------------------------------------------------',
  toolbox_matrix_label_text: '----------------------------------------------- Text Blöcke -------------------------------------------------',
  toolbox_matrix_label_frame_buffer: '----------------------------------------- Bildspeicher Blöcke -------------------------------------------',
  toolbox_matrix_label_get_pixels: '------------------------------------------- Lies Pixel Blöcke ---------------------------------------------',
  toolbox_time_label_time: '----------------------------------------------- Zeit Blöcke ---------------------------------------------------',
  toolbox_time_label_online_time: '------------------------------------------ Online Zeit Blöcke ---------------------------------------------',
  toolbox_communication_label_general: '-------------------------------------------- Generelle Blöcke ---------------------------------------------',
  toolbox_speaker_label_play_tone: '------------------------------------------- Spiele Ton Blöcke -------------------------------------------',
  toolbox_speaker_label_configure_tone: '-------------------------------------- Konfiguriere Ton Blöcke --------------------------------------',
  toolbox_speaker_label_volume: '------------------------------------------- Lautstärke Blöcke -------------------------------------------',
  toolbox_speaker_label_sound_effect: '----------------------------------------- Soundeffekt Blöcke -------------------------------------------',
  toolbox_extras_label_gpios: '------------------------------------------------ GPIO Blöcke -----------------------------------------------',
  toolbox_extras_label_console: '--------------------------------------------- Konsolen Blöcke ---------------------------------------------',
  toolbox_extras_label_push_values: '----------------------------------------------- Daten Blöcke -----------------------------------------------',
  toolbox_extras_label_i2c: '------------------------------------------------- I2C Blöcke -------------------------------------------------',

  'right-area-news': 'Jetzt lesen (News)',
  'right-area-instructions': 'Anleitung',
  'right-area-simulator': 'Simulator',
  'right-area-my-oxocards': 'Meine Oxocard',
  'right-area-worksheets': 'Arbeitsblätter',
  'right-area-booklet-examples': 'Buch: Achtung, fertig, Code!',
  'right-area-examples': 'Beispiele',
  'right-area-blockly-console': 'Konsole',
  'right-area-blockly-variables': 'Daten',
  'right-area-source-code': 'Programmcode',
  'right-area-feedback': 'Rückmeldung',

  'right-area-toggle-button': 'Menu verkleinern',
  'right-area-show': 'Anleitung',
  'right-area-template': 'Vorlage',
  'right-area-solution': 'Lösung',

  'right-area-simulator-reset': 'Karte neustarten',
  simulator_unknown_function: 'wird vom Simulator nicht unterstützt',
  simulator_compile_error: 'Fehler im Programm',

  'right-area-my-oxocard-no-card': 'Du hast noch keine Karte verbunden.',
  'right-area-my-oxocard-card-connected': 'Du bist mit {{CARD_NAME}} verbunden.',
  'right-area-my-oxocard-connect-card': 'Verknüpfe eine Karte',
  'right-area-my-oxocard-other-card': 'Verknüpfe eine andere Karte',
  'right-area-my-oxocard-default-image': 'Setze die Karte zurück',
  'right-area-my-oxocard-rename-card': 'Benenne die Karte um',
  'right-area-my-oxocard-oxoscript': 'Wechsle zu Oxoscript',

  'right-area-blockly-console-title': 'Hier findest du die <strong>Textnachrichten</strong> die du mit deiner Oxocard an dein Blockly (Browser) gesendet hast.',
  'right-area-blockly-console-note-title': 'Hinweise:',
  'right-area-blockly-console-note-text1': 'Du findest den "Sende Text an Konsole"-Block in der Extras-Kategorie.',
  'right-area-blockly-console-clear-data': 'Löschen',
  'right-area-blockly-console-no-data': 'Keine Daten',
  'right-area-blockly-console-last-data-value': 'Aktuell',

  'right-area-blockly-variables-title': 'Hier findest du die <strong>Variablen</strong> die du mit deiner Oxocard an dein Blockly (Browser) gesendet hast.',
  'right-area-blockly-variables-note-title': 'Hinweise:',
  'right-area-blockly-variables-note-text1': 'Du findest den "Sende Wert an Variable"-Block in der Extras-Kategorie.',
  'right-area-blockly-variables-note-text2': 'Es können maximal 100 Werte pro Variable gespeichert und angezeigt werden.',
  'right-area-blockly-variables-public-link': 'Teilen-Link',
  'right-area-blockly-variables-csv-export': 'CSV Export',
  'right-area-blockly-variables-clear-data': 'Löschen',
  'right-area-blockly-variables-data-graph': 'Daten Graf',
  'right-area-blockly-variables-no-data': 'Keine Daten',
  'right-area-blockly-variables-last-data-value': 'Aktuell',

  'right-area-feedback-title': 'Bitte gib uns ein Feedback, damit wir unsere Oxocard und unser Blockly verbessern können:',
  'right-area-feedback-placeholder': 'Deine Rückmeldung...',
  'right-area-feedback-email-placeholder': 'Deine E-Mail Adresse (Optional)',
  'right-area-feedback-send': 'Abschicken',
  'right-area-feedback-mail-to': 'Sende uns ein Mail',
  'right-area-feedback-imprint': 'Impressum',
  'right-area-feedback-imprint-href': 'https://oxocard.ch/de/impressum/',

  'right-area-worksheet-link-001': 'media/worksheets/A001_Blockly2.pdf',
  'right-area-worksheet-link-002': 'media/worksheets/A002_Blockly2.pdf',
  'right-area-worksheet-link-003': 'media/worksheets/A003_Blockly2.pdf',
  'right-area-worksheet-link-004': 'media/worksheets/A004_Blockly2.pdf',
  'right-area-worksheet-link-005': 'media/worksheets/A005_Blockly2.pdf',
  'right-area-worksheet-link-006': 'media/worksheets/A006_Blockly2.pdf',
  'right-area-worksheet-link-007': 'media/worksheets/A007_Blockly2.pdf',
  'right-area-worksheet-link-008': 'media/worksheets/A008_Blockly2.pdf',
  'right-area-worksheet-link-009': 'media/worksheets/A009_Blockly2.pdf',
  'right-area-worksheet-link-010': 'media/worksheets/A010_Blockly2.pdf',
  'right-area-worksheet-link-011': 'media/worksheets/A011_Blockly2.pdf',
  'right-area-worksheet-link-012': 'media/worksheets/A012_Blockly2.pdf',
  'right-area-worksheet-link-013': 'media/worksheets/A013_Blockly2.pdf',
  'right-area-worksheet-link-014': 'media/worksheets/A014_Blockly2.pdf',
  'right-area-worksheet-link-015': 'media/worksheets/A015_Blockly2.pdf',
  'right-area-worksheet-link-016': 'media/worksheets/A016_Blockly2.pdf',
  'right-area-worksheet-link-017': 'media/worksheets/A017_Blockly2.pdf',
  'right-area-worksheet-link-018a': 'media/worksheets/A018a_Blockly2.pdf',
  'right-area-worksheet-link-018b': 'media/worksheets/A018b_Blockly2.pdf',
  'right-area-worksheet-link-019': 'media/worksheets/A019_Blockly2.pdf',
  'right-area-worksheet-link-020': 'media/worksheets/A020_Blockly2.pdf',
  'right-area-worksheet-link-021': 'media/worksheets/A021_Blockly2.pdf',
  'right-area-worksheet-link-022': 'media/worksheets/A022_Blockly2.pdf',
  'right-area-worksheet-link-023': 'media/worksheets/A023_Blockly2.pdf',
  'right-area-worksheet-link-024': 'media/worksheets/A024_Blockly2.pdf',
  'right-area-worksheet-link-025': 'media/worksheets/A025_Blockly2.pdf',
  'right-area-worksheet-link-026': 'media/worksheets/A026_Blockly2.pdf',
  'right-area-worksheet-link-027': 'media/worksheets/A027_Blockly2.pdf',

  'right-area-news-link-june2019': 'media/news/june_2019_de.pdf',
  'right-area-news-link-september2019': 'media/news/september_2019_de.pdf',
  'right-area-news-link-november2019': 'media/news/november_2019_de.pdf',
  'right-area-news-link-december2019': 'media/news/december_2019_de.pdf',
  'right-area-news-link-august2020': 'https://mailchi.mp/348f636f65fd/sonderaktion-und-andere-news-8003280',
  'right-area-news-link-february2021': 'media/news/february_2021_de.pdf',

  'right-area-instructions-video-link': 'https://www.youtube.com/playlist?list=PLSZShxI-zRnt12wnWJQLNeH1xT0acsMzD',
  'right-area-instructions2018-video-link': 'https://youtu.be/Nk_VvHbkCj4',
  'right-area-instructions-link': 'media/instructions/instructions_2019_de.pdf',
  'right-area-instructions2018-link': 'media/instructions/instructions_2018_de.pdf',
  'right-area-instructions-key-commands-link': 'media/instructions/Oxocardbefehle.pdf',

  'right-area-open-in-oxoscript': 'Im Oxoscript-Editor öffnen',

  popupSettingsEditorTitle: 'Einstellungen',
  popupSettingsEditorPositiveButton: 'Speichern',
  user_settings_expertModeActive: 'Aktiviere den Experten-Modus',
  user_settings_showInstructions: 'Zeige Hilfestellungen',
  user_settings_showAlwaysOldInstructions: '&emsp;&emsp;Zeige nur die alten Hilfestellungen (2018)',
  user_settings_uiLanguageV1: 'Bevorzugte Sprache',
  user_settings_uiLanguageV1_option_de: 'Deutsch',
  user_settings_uiLanguageV1_option_en: 'English',
  user_settings_uiLanguageV1_option_fr: 'Français',

  defaultPopupTitle: 'Hinweis',
  defaultPopupPositiveButton: 'OK',
  defaultPopupNegativeButton: 'Abbrechen',
  defaultPopupContinueButton: 'Fortfahren',

  // no connectivity popup
  popupNoConnectivityTitle: 'Du hast keine Internetverbindung',
  popupNoConnectivityBody: 'Kein Grund zur Sorge! Sobald du wieder verbunden bist, verschwindet dieses Fenster.',

  // API not reachable popup
  popupApiNotReachableTitle: 'Unser Server scheint nicht erreichbar zu sein',
  popupApiNotReachableBody: 'Du kannst im Moment keine Programme auf deine Karte laden. Versuche es in ein paar Minuten wieder.',

  // API reachable again popup
  popupApiReachableAgainTitle: 'Unser Server scheint wieder erreichbar zu sein',
  popupApiReachableAgainBody: 'Du kannst nun wieder Programme auf deine Karte laden.',

  // no cards popup
  popupNoCardsTitle: 'Es ist keine Oxocard verbunden',
  popupNoCardsBody: 'Kein Grund zur Sorge! Würdest du gerne eine verbinden?',
  popupShareButtonNoCardsBody: 'Damit du dein Skript teilen kannst, musst du eine Oxocard verbinden.<br>Würdest du gerne eine verbinden?',
  popupNoCardsNo: 'Nein',
  popupNoCardsYes: 'Ja, gerne!',

  // connect popup
  connectPopupTitle: 'Verbinde eine Oxocard',
  connectPopupContent: 'Bitte tippe die Farbkombination von deiner Oxocard ab.',
  connectPopupConnectButton: 'Verbinden',

  // connect success popup
  popupConnectSuccessTitle: 'Deine Oxocard ist nun verknüpft!',
  popupConnectSuccessBody: 'Du hast die Oxocard erfolgreich verknüpft.<br />Du kannst nun loslegen mit Programmieren.',
  popupConnectSuccessOK: 'Super!',

  // connect error popup
  popupConnectErrorTitle: 'Wir konnten deine Oxocard leider nicht finden',
  popupConnectErrorBody: 'Irgendwo gabs da ein Problem. Willst du\'s nochmals versuchen?',
  popupConnectErrorNo: 'Nein, danke...',
  popupConnectErrorYes: 'Ja, gerne!',

  // feedback success popup
  popupFeedbackSuccessBody: 'Deine Rückmeldung ist unterwegs! Wir bedanken uns dafür.',
  popupFeedbackSuccessOK: 'Alles klar!',

  // feedback failure popup
  popupFeedbackErrorBody: 'Leider hat das Rückmelden nicht geklappt. Dürfen wir Dich bitten uns eine Mail zu schreiben? <a href="mailto:info@oxocard.ch">info@oxocard.ch</a>',
  popupFeedbackErrorClose: 'Schliessen',

  // save before quit popup
  popupSaveBeforeQuitText: 'Du hast noch ungespeichtere Blöcke. Bist du sicher?',

  // compilation error popup
  popupCompilationFailedTitle: 'Fehler beim Kompilieren',
  popupCompilationFailedBody: 'Leider ging da was schief. Bist Du sicher, dass deine Blöcke korrekt sind?',

  // flashing error popup
  popupFlashingFailedTitle: 'Fehler beim hochladen',
  popupFlashingFailedBody: 'Leider ging da was schief. Möchtest Du es nochmals versuchen?',
  popupFlashingFailedNo: 'Nein',
  popupFlashingFailedYes: 'Ja',

  // update available popup
  popupUpdateAvailableTitle: 'Es ist eine neue Version verfügbar',
  popupUpdateAvailableBody: 'Wenn Du willst - und wir empfehlen es - kannst du nun ein Update einspielen.',
  popupUpdateAvailableNo: 'Nein',
  popupUpdateAvailableYes: 'Ja, gerne!',

  // unsaved changes popup
  popupUnsavedChangesTitle: 'Du hast ein ungespeichertes Script!',
  popupUnsavedChangesBody: 'Falls du fortfährst ohne zu speichern verlierst du deine Änderungen. Willst du fortfahren?',
  popupUnsavedChangesCancel: 'Nein!',
  popupUnsavedChangesContinue: 'Weiter',

  // really unpair? popup
  popupUnpairTitle: 'Deine Oxocard wird abgemeldet.',
  popupUnpairBody: 'Du kannst sie jederzeit wieder verknüpfen. Möchtest du fortfahren?',
  popupUnpairNo: 'Nein',
  popupUnpairYes: 'Ja!',

  /* Popup - Really reset */
  popup_really_reset_title: 'Willst du die Karte wirklich zurücksetzen?',
  popup_really_reset_body: 'Wenn Du auf Reset drückst, werden alle gesendeten Daten deiner Oxocard gelöscht. Versetzt Du deine Oxocard anschliessend in den Update-Modus wird das Standard-Programm wiederhergestellt.',
  popup_really_reset_cancel: 'Nein!',
  popup_really_reset_continue: 'Reset',

  /* Popup - Switch to Oxoscript */
  popup_switch_to_oxoscript_title: 'Möchtest du lieber Text-Code programmieren?',
  popup_switch_to_oxoscript_body: 'Wenn du in den Oxoscript-Editor wechselst, wird die Verknüpfung mit Blockly aufgelöst. Du kannst jederzeit wieder zurückwechseln.',
  popup_switch_to_oxoscript_cancel: 'Im Blockly bleiben',
  popup_switch_to_oxoscript_continue: 'Zum Editor wechseln',

  /* Popup - Really clear data */
  popup_really_clear_data_title: 'Willst du diese Daten wirklich löschen?',
  popup_really_clear_data_body: 'Wenn Du auf Ja drückst, werden alle Daten dieser Variable unwiderruflich gelöscht.',
  popup_really_clear_data_cancel: 'Nein',
  popup_really_clear_data_continue: 'Ja',

  /* Popup - Really delete variable */
  popup_really_delete_variable_title: 'Keine Daten vorhanden. Willst du die Variable löschen?',
  popup_really_delete_variable_body: 'Wenn Du auf Ja drückst, wird die Variable unwiderruflich gelöscht.',
  popup_really_delete_variable_cancel: 'Nein',
  popup_really_delete_variable_continue: 'Ja',

  // pairing instructions
  popupPairingInstructionsBody: 'Mit Hilfe der oben angezeigten Tastenkombination und Reihenfolge<br />kannst Du deine Karte verknüpfen.',
  popupPairingInstructionsCheckbox: 'Diese Hilfe nicht mehr anzeigen',

  // pairing instructions 2019
  popupPairingInstructions2019Body: 'Drücke den oben angezeigten Knopf, bis das Verknüpfen-Symbol erscheint.',
  popupPairingInstructions2019Checkbox: 'Diese Hilfe nicht mehr anzeigen',

  // Stage instructions
  popupUpdatingBody: 'Mit Hilfe der oben angezeigten Tastenkombination und Reihenfolge<br />kannst Du deine karte in den Update-Modus versetzen.',
  popupUpdatingCheckbox: 'Diese Hilfe nicht mehr anzeigen',
  popupUpdatingButtonCancel: 'Abbrechen',
  popupUpdatingButtonContinue: 'Fortfahren',

  // Update mode instructions
  popupUpdateModeInstructionsBody: 'Mit Hilfe der oben angezeigten Tastenkombination und Reihenfolge<br />kannst Du deine karte in den Update-Modus versetzen.',
  popupUpdateModeInstructionsButtonOK: 'Fertig',

  // Update mode instructions 2019
  popupUpdateModeInstructions2019Body: 'Drücke den oben angezeigten Knopf, bis das Update-Symbol erscheint.',
  popupUpdateModeInstructions2019ButtonOK: 'Fertig',

  // invalid block-state popup
  popupInvalidBlocksFailedTitle: 'Deine Blöcke sind nicht korrekt angeordnet',
  popupInvalidBlocksFailedBody: 'Du solltest nochmals alle deine Blöcke kontrollieren.<ul><li>Hast du keinen oder mehrere Einstiegspunkte?</li><li>Hast du Blöcke, die nicht korrekt eingehängt sind?</li><li>Verstecken sich Blöcke ausserhalb der aktuellen Ansicht oder hinter anderen Blöcken?</li><li>Hast du noch undefinierte (nicht initialisierte) Variablen?</li></ul>',
  popupInvalidBlocksFailedIgnore: 'Ignorieren',
  popupInvalidBlocksFailedRetry: 'Verbessern',

  popupDefaultImageSuccessBody: 'Das Programm wurde der Oxocard bereitgestellt. Versetze Deine Karte in den Update-Modus, um es herunterzuladen.',
  popupDefaultImageSuccessCancel: 'Fertig',
  popupDefaultImageSuccessOK: 'Update-Modus',

  popupDefaultImageFailureBody: 'Etwas ist schief gelaufen während dem zurücksetzen der Karte. Probiere es doch nochmals.',
  popupDefaultImageFailureOK: 'Schliessen',

  // set name popup
  popupSetNameTitle: 'Neuer Name für deine Oxocard',
  popupSetNameSave: 'Speichern',
  popupSetNameAvailable: 'Dieser Name ist verfügbar.',
  popupSetNameNotAvailable: 'Dieser Name ist leider schon vergeben.',
  popupSetNameHint: '<p>Wir haben grundsätzliche Änderungen an der Komponente "Kommunikation" vorgenommen. Dadurch musst Du Deiner Oxocard neuerdings einen eindeutig identifizierbaren Namen geben. Dies erlaubt es Dir einfacher mit Deinen Oxocard-Freunden zu kommunzieren.</p><p>Leider hat Deine Oxocard im Moment keinen eindeutigen Namen. Du kannst einen anonymisierten Namen jetzt erstellen lassen oder selber einen wählen.</p>',
  popupSetNameRules: '<p>Beachte bitte folgende Regeln:<p><ul><li>Keine Leertaste</li><li>Keine Sonderzeichen</li><li>Mindestens 8, Maximal 30 Zeichen lang</li><li>Mindestens eine Zahl</li></ul>',
  popupSetNameNotValid: 'Dieser Name entspricht nicht unseren Regeln.',
  popupSetNameRandom: 'Zufall',
  popupSetNameLabel: 'Neuer Name',

  // set name success popup
  popupSetNameSuccessTitle: 'Deine Oxocard wurde umbenennt',
  popupSetNameSuccessBody: 'Du hast die Oxocard erfolgreich umbenennt.<br />Du kannst nun loslegen mit Programmieren.',
  popupSetNameSuccessOK: 'Super!',

  // set name error popup
  popupSetNameErrorTitle: 'Wir konnten deine Oxocard leider nicht umbenennen',
  popupSetNameErrorBody: 'Irgendwo gabs da ein Problem. Willst du\'s nochmals versuchen?',
  popupSetNameErrorNoClient: 'Irgendwo gabs ein Problem mit der Datenstruktur Deiner Oxocard. Das heisst Du musst Deine Oxocard erneut verbinden.',
  popupSetNameErrorNo: 'Nein, danke...',
  popupSetNameErrorYes: 'Ja, gerne!',

  // publish script popup
  popupShareCodeTitle: 'Dein Link wurde erstellt!',
  popupShareCodeBody: 'Teile diesen Link mit deinen Freunden oder speichere ihn unter deinen Favoriten.',
  popupShareCodeCloseButton: 'Schliessen',
  popupShareCodeCopyButton: 'Kopiere Link',
  popupShareCodeCopyButtonFeedbackPositive: 'Link wurde kopiert!',
  popupShareCodeCopyButtonFeedbackNegative: 'Link nicht kopiert!',
  popupShareCodeEmailButton: 'Verschicke Email',
  publishScriptEmailSubject: 'Schau dir mein Script an',

  popupShareCodeFailedTitle: 'Da ist etwas schief gelaufen',
  popupShareCodeFailedBody: 'Leider konnte dein Link nicht erstellt werden. Versuche es später nochmals.',
  popupShareCodeFailedButton: 'Schliessen',

  // invalid hash popup
  popupInvalidHashTitle: 'Das Script kann nicht geöffnet werden',
  popupInvalidHashBody: 'Der Grund dafür kann sein, dass der Link nicht korrekt ist. Auch kann es sein, dass er abgelaufen ist.',
  popupInvalidHashClose: 'Schliessen',

  // firmware selection
  popupFirmwareSelectionTitle: 'Welche Firmwareversion hat deine Oxocard?',
  popupFirmwareSelectionBody2019: '<h3><b>Version 2019</b></h3><p>Wenn du nach einem Reset das animierte Oxocard Logo siehst, drücke den nachfolgenden Knopf.<br></p>',
  popupFirmwareSelectionBody2018: '<h3><b>Version 2018</b></h3><p>Wenn du nach einem Reset direkt einen Smiley oder das Oxocard-Logo auflechten siehst, drücke den nachfolgenden Knopf.</p>',
  popupFirmwareSelectionButton: 'Drücke hier',

  // old firmware version
  popupOldFwVersionTitle: 'Deine Oxocard ist nun verknüpft!',
  popupOldFwVersionMessage: 'Bevor du aber mit der Oxocard starten kannst, müssen wir ein wichtiges Update einspielen. Wechsle nun die Karte in den Update-Modus. Danach musst du die Karte nochmals neu verknüpfen.',

  // news
  news: 'Neuigkeiten',
  newsJune2019LinkPDF: 'Juni 2019',
  newsSeptember2019LinkPDF: 'September 2019',
  newsNovember2019LinkPDF: 'November 2019',
  newsDecember2019LinkPDF: 'Dezember 2019',
  newsAugust2020LinkPDF: 'August 2020',
  newsFebruary2021LinkPDF: 'Februar 2021',
  newsLastUpdate: 'Letztes Update',

  // instructions
  instructions: 'Erste Schritte um die Oxocard in Betrieb zu nehmen',
  instructionsButtonVideo: 'Video',
  instructionsButtonPDF: 'Anleitung (PDF)',
  instructions2018LinkPDF: 'Hier gehts zur alten Anleitung (2018)',
  instructions2018LinkVideo: 'Hier gehts zum alten Video (2018)',
  instructionsKeyCommands: 'Alle Oxocard Tastenkombination',
  instructionsTitle: 'Blockly kurz erklärt',
  instructions01: 'Einzelne Blöcke können links in den verschiedenen Kategorien ausgewählt und in den mittleren Arbeitsbereich gezogen werden.',
  instructions02: 'Wenn man in den Arbeitsbereich klickt und gedrückt hält, können alle Blöcke miteinander verschoben werden.',
  instructions03: 'Ein Blockly-Programm fängt oben an und hört unten auf. Es wird Block für Block nacheinander ausgeführt.',
  instructions04: 'Alle Blöcke müssen miteinander verbunden (zusammengeklickt) werden.',
  instructions05: 'Sobald der letzte Block ausgeführt wurde, schaltet sich die Karte ab. Falls dein Programm aufgrund einer Schleife nie einen letzten Block erreicht, schaltet sich die Karte nach zwei Minuten automatisch ab.',
  instructions06: 'Wenn du die Knöpfe L2 (links unten aussen) und L3 (links unten innen) zusammen kurz drückst, resettet sich die Oxocard.',
  instructions07: 'Wenn du den Knopf L1 (links oben) drücks und hältst und dann die Knöpfe R2 (rechts unten aussen) und R3 (rechts unten innen) zusammen kurz drückst, schaltet sich die Oxocard aus.',
  instructions08: 'In den Einstellungen kannst du alle verfügbaren Blöcke für die Oxocard (Experten-Blöcke) aktivieren.',

  // worksheet templates
  worksheetTemplate01: 'Arbeitsblatt 01 - Pixelbild',
  worksheetTemplate02: 'Arbeitsblatt 02 - Laufschrift',
  worksheetTemplate03: 'Arbeitsblatt 03 - Animation',
  worksheetTemplate04: 'Arbeitsblatt 04 - Farben',
  worksheetTemplate05: 'Arbeitsblatt 05 - Grafikbefehle',
  worksheetTemplate06: 'Arbeitsblatt 06 - Smiley-Maschine',
  worksheetTemplate07: 'Arbeitsblatt 07 - Ein-Mal-Eins',
  worksheetTemplate08: 'Arbeitsblatt 08 - Bedingungen',
  worksheetTemplate09: 'Arbeitsblatt 09 - Zufall',
  worksheetTemplate10: 'Arbeitsblatt 10 - Klavier',
  worksheetTemplate11: 'Arbeitsblatt 11 - Beschleunigung',
  worksheetTemplate12: 'Arbeitsblatt 12 - Winkel',
  worksheetTemplate13: 'Arbeitsblatt 13 - Kaleidoskop',
  worksheetTemplate14: 'Arbeitsblatt 14 - Cursor',
  worksheetTemplate15: 'Arbeitsblatt 15 - Wetterprogramm',
  worksheetTemplate16: 'Arbeitsblatt 16 - Wecker',
  worksheetTemplate17: 'Arbeitsblatt 17 - Mikrofon',
  worksheetTemplate18a: 'Arbeitsblatt 18a - Senden *',
  worksheetTemplate18b: 'Arbeitsblatt 18b - Empfangen *',
  worksheetTemplate19: 'Arbeitsblatt 19 - Liste',
  worksheetTemplate20: 'Arbeitsblatt 20 - Funktionen',
  worksheetTemplate21: 'Arbeitsblatt 21 - Simple Snake',
  worksheetTemplate22: 'Arbeitsblatt 22 - Lokale Kommunikation *',
  worksheetTemplate23: 'Arbeitsblatt 23 - Lokale Kommunikation 2 *',
  worksheetTemplate24: 'Arbeitsblatt 24 - Globale Kommunikation *',
  worksheetTemplate25: 'Arbeitsblatt 25 - Ampel',
  worksheetTemplate26: 'Arbeitsblatt 26 - Sensordaten',
  worksheetTemplate27: 'Arbeitsblatt 27 - Print',

  communicationWorksheets: '* Für diese Arbeitsblätter werden zwei Oxocards benötigt',

  // worksheet solutions
  worksheetSolution01: 'Lösung 01 - Pixelbild',
  worksheetSolution02: 'Lösung 02 - Laufschrift',
  worksheetSolution03: 'Lösung 03 - Animation',
  worksheetSolution04: 'Lösung 04 - Farben',
  worksheetSolution05: 'Lösung 05 - Grafikbefehle',
  worksheetSolution06: 'Lösung 06 - Smiley-Maschine',
  worksheetSolution07: 'Lösung 07 - Ein-Mal-Eins',
  worksheetSolution08: 'Lösung 08 - Bedingungen',
  worksheetSolution09: 'Lösung 09 - Zufall',
  worksheetSolution10: 'Lösung 10 - Klavier',
  worksheetSolution11: 'Lösung 11 - Beschleunigung',
  worksheetSolution12: 'Lösung 12 - Winkel',
  worksheetSolution13: 'Lösung 13 - Kaleidoskop',
  worksheetSolution14: 'Lösung 14 - Cursor',
  worksheetSolution15: 'Lösung 15 - Wetterprogramm',
  worksheetSolution16: 'Lösung 16 - Wecker',
  worksheetSolution17: 'Lösung 17 - Mikrofon',
  worksheetSolution18a: 'Lösung 18a - Senden',
  worksheetSolution18b: 'Lösung 18b - Empfangen',
  worksheetSolution19: 'Lösung 19 - Liste',
  worksheetSolution20: 'Lösung 20 - Funktionen',
  worksheetSolution21: 'Lösung 21 - Simple Snake',
  worksheetSolution22: 'Lösung 22 - Lokale Kommunikation',
  worksheetSolution23: 'Lösung 23 - Lokale Kommunikation 2',
  worksheetSolution24: 'Lösung 24 - Globale Kommunikation',
  worksheetSolution25: 'Lösung 25 - Ampel',
  worksheetSolution26: 'Lösung 26 - Sensordaten',
  worksheetSolution27: 'Lösung 27 - Print',

  // booklet exercise templates
  bookletExerciseTemplate01: 'Aufgabe 01 - Einfarbiges Bild',
  bookletExerciseTemplate02: 'Aufgabe 02 - Animation',
  bookletExerciseTemplate03a: 'Aufgabe 03a - Grafikbefehle',
  bookletExerciseTemplate03b: 'Aufgabe 03b - Grafikbefehle',
  bookletExerciseTemplate03c: 'Aufgabe 03c - Grafikbefehle',
  bookletExerciseTemplate04: 'Aufgabe 04 - Blume',
  bookletExerciseTemplate05a: 'Aufgabe 05a - Smiley-Maschine',
  bookletExerciseTemplate05b: 'Aufgabe 05b - Smiley durch Neigung',
  bookletExerciseTemplate06: 'Aufgabe 06 - Countdown',
  bookletExerciseTemplate07: 'Aufgabe 07 - Zahlenreihen',
  bookletExerciseTemplate08: 'Aufgabe 08 - Animation mit Schleife',
  bookletExerciseTemplate09: 'Aufgabe 09 - Bild einfärben',
  bookletExerciseTemplate10a: 'Aufgabe 10a - Melodie',
  bookletExerciseTemplate10b: 'Aufgabe 10b - Klavier',
  bookletExerciseTemplate11: 'Aufgabe 11 - Töne und Geräusche',
  bookletExerciseTemplate12: 'Aufgabe 12 - Würfelmaschine',
  bookletExerciseTemplate13: 'Aufgabe 13 - Zufällige Pixel',
  bookletExerciseTemplate14: 'Aufgabe 14 - Zufällige Töne',
  bookletExerciseTemplate15: 'Aufgabe 15 - Fallende Pixel',
  bookletExerciseTemplate16: 'Aufgabe 16 - Berechneter Zufall',
  bookletExerciseTemplate17: 'Aufgabe 17 - Kippen und Rollen',
  bookletExerciseTemplate18: 'Aufgabe 18 - Fang das Pixel',
  bookletExerciseTemplate19a: 'Aufgabe 19a - Einfache Uhr',
  bookletExerciseTemplate19b: 'Aufgabe 19b - Einfache Uhr (Zusatzaufgabe)',
  bookletExerciseTemplate20_s: 'Aufgabe 20 - Kurznachrichten (senden)',
  bookletExerciseTemplate20_r: 'Aufgabe 20 - Kurznachrichten (empfangen)',

  // booklet exercise solutions
  bookletExerciseSolution01: 'Lösung 01 - Einfarbiges Bild',
  bookletExerciseSolution02: 'Lösung 02 - Animation',
  bookletExerciseSolution03a: 'Lösung 03a - Grafikbefehle',
  bookletExerciseSolution03b: 'Lösung 03b - Grafikbefehle',
  bookletExerciseSolution03c: 'Lösung 03c - Grafikbefehle',
  bookletExerciseSolution04: 'Lösung 04 - Blume',
  bookletExerciseSolution05a: 'Lösung 05a - Smiley-Maschine',
  bookletExerciseSolution05b: 'Lösung 05b - Smiley durch Neigung',
  bookletExerciseSolution06: 'Lösung 06 - Countdown',
  bookletExerciseSolution07: 'Lösung 07 - Zahlenreihen',
  bookletExerciseSolution08: 'Lösung 08 - Animation mit Schleife',
  bookletExerciseSolution09: 'Lösung 09 - Bild einfärben',
  bookletExerciseSolution10a: 'Lösung 10a - Melodie',
  bookletExerciseSolution10b: 'Lösung 10b - Klavier',
  bookletExerciseSolution11: 'Lösung 11 - Töne und Geräusche',
  bookletExerciseSolution12: 'Lösung 12 - Würfelmaschine',
  bookletExerciseSolution13: 'Lösung 13 - Zufällige Pixel',
  bookletExerciseSolution14: 'Lösung 14 - Zufällige Töne',
  bookletExerciseSolution15: 'Lösung 15 - Fallende Pixel',
  bookletExerciseSolution16: 'Lösung 16 - Berechneter Zufall',
  bookletExerciseSolution17: 'Lösung 17 - Kippen und Rollen',
  bookletExerciseSolution18: 'Lösung 18 - Fang das Pixel',
  bookletExerciseSolution19a: 'Lösung 19a - Einfache Uhr',
  bookletExerciseSolution19b: 'Lösung 19b - Einfache Uhr (Zusatzaufgabe)',
  bookletExerciseSolution20_s: 'Lösung 20 - Kurznachrichten (senden)',
  bookletExerciseSolution20_r: 'Lösung 20 - Kurznachrichten (empfangen)',

  // example titles
  exampleTitleSimple: 'Einfach',
  exampleTitleAdvanced: 'Fortgeschritten',
  exampleTitleExpert: 'Experte (Games)',

  // examples
  exampleNameSmiley: 'Smiley',
  exampleTemplateSmiley: 'Beispiel - Smiley',
  exampleNameWink: 'Zwinkern',
  exampleTemplateWink: 'Beispiel - Zwinkern',
  exampleNameFalling_pixel: 'Fallendes Pixel',
  exampleTemplateFalling_pixel: 'Beispiel - Fallendes Pixel',
  exampleNameKaleidoscope: 'Kaleidoskop',
  exampleTemplateKaleidoscope: 'Beispiel - Kaleidoskop',
  exampleNamePiano: 'Klavier',
  exampleTemplatePiano: 'Beispiel - Klavier',
  exampleNameSimple_communication: 'Einfache Kommunikation (2 Karten nötig)',
  exampleTemplateSimple_communication: 'Beispiel - Einfache Kommunikation',
  exampleNameRainbow: 'Regenbogen',
  exampleTemplateRainbow: 'Beispiel - Regenbogen',
  exampleNameWeather: 'Wetter',
  exampleTemplateWeather: 'Beispiel - Wetter',
  exampleNameBattery: 'Batterie',
  exampleTemplateBattery: 'Beispiel - Batterie',
  exampleNameHangman: 'Henkerspiel',
  exampleTemplateHangman: 'Beispiel - Henkerspiel',
  exampleNameMoving_pixel: 'Bewegendes Pixel',
  exampleTemplateMoving_pixel: 'Beispiel - Bewegendes Pixel',
  exampleNameRain: 'Regen',
  exampleTemplateRain: 'Beispiel - Regen',
  exampleNameLong_image: 'Langes Bild',
  exampleTemplateLong_image: 'Beispiel - Langes Bild',
  exampleNameWhistle: 'Pfeifen',
  exampleTemplateWhistle: 'Beispiel - Pfeifen',
  exampleNameNoise_meter: 'Lärmmesser',
  exampleTemplateNoise_meter: 'Beispiel - Lärmmesser',
  exampleNameLocal_communication: 'Lokale Kommunikation (2 Karten nötig)',
  exampleTemplateLocal_communication: 'Beispiel - Lokale Kommunikation',
  exampleNameGlobal_communication: 'Globale Kommunikation (2 Karten nötig)',
  exampleTemplateGlobal_communication: 'Beispiel - Globale Kommunikation',
  exampleNameCarousel: 'Karussell Spiel',
  exampleTemplateCarousel: 'Beispiel - Karussell Spiel',
  exampleNamePainter: 'Painter',
  exampleTemplatePainter: 'Beispiel - Painter',
  exampleNameColor_game: 'Memory (Simon says)',
  exampleTemplateColor_game: 'Beispiel - Memory (Simon says)',
  exampleNameDrop_game: 'Drop the Game',
  exampleTemplateDrop_game: 'Beispiel - Drop the Game',
  exampleNameRock_Paper_Scissors: 'Schere-Stein-Papier (2 Karten nötig)',
  exampleTemplateRock_Paper_Scissors: 'Beispiel - Schere-Stein-Papier',
  exampleNameMini_Pong: 'Mini Pong',
  exampleTemplateMini_Pong: 'Beispiel - Mini Pong',

  // AH01 examples (DE only)
  exampleTemplateAh01_a01_einfache_wellen: 'AH01 Aufgabe 01 - Einfache Wellen',
  exampleTemplateAh01_a02_leuchtende_herzchen: 'AH01 Aufgabe 02 - Leuchtende Herzchen',
  exampleTemplateAh01_a03_pyramide: 'AH01 Aufgabe 03 - Pyramide',
  exampleTemplateAh01_a04_flackern_reduzieren: 'AH01 Aufgabe 04 - Flackern reduzieren',
  exampleTemplateAh01_v05_mehrfarbige_bilder: 'AH01 Vorlage 05 - Mehrfarbige Bilder',
  exampleTemplateAh01_a05_mehrfarbige_bilder: 'AH01 Aufgabe 05 - Mehrfarbige Bilder',
  exampleTemplateAh01_a06_richtung_erkennen: 'AH01 Aufgabe 06 - Richtung erkennen',
  exampleTemplateAh01_v07_texte_ausgeben: 'AH01 Vorlage 07 - Texte ausgeben',
  exampleTemplateAh01_a07_texte_ausgeben: 'AH01 Aufgabe 07 - Texte ausgeben',
  exampleTemplateAh01_a07_texte_ausgeben_be_cool: 'AH01 Aufgabe 07 - Texte ausgeben (be cool)',

  // Editor
  settingsFeatureIntroTitle: 'Zeige neue Funktionen beim laden des Editors?',
  settingsFeatureIntroNew: 'Neue Änderungen',
  settingsFeatureIntroAlways: 'Immer anzeigen',
  settingsFeatureIntroNever: 'Nie anzeigen',
  feedback: 'Bitte gib uns ein Feedback, damit wir unsere Oxocard und unser Editor verbessern können:',
  rebootCard: 'Karte neu starten',
  shutDownCard: 'Karte ausschalten',
  documentation: 'Dokumentation',
  searchDocumentation: 'Dokumentation durchsuchen',
  clearOutput: 'Löschen',
  output: 'Output',
  cmdTimedOutTitle: 'Zeitüberschreitung beim ausführen des Befehls.',
  cmdTimedOutMsg: 'Ist Deine Karte verbunden?',
  wsConnection: 'WS Verbindung',
  cardConnection: 'Verbindung zur Karte',
  editorMenuTitle: 'Editor',
  editorThemeLight: 'Hell',
  editorThemeDark: 'Dunkel',
  settingsEditorTheme: 'Editor Design wechseln:',
  toasts: {
    wsOpenSuccess: 'Websocket Verbindung erstellt',
    wsOpenFail: 'Wir konnten keine Websocket verbindung erstellen',
    cardOpen: 'Verbindung zur Karte erstellt',
    cardClose: 'Verbindung zur Karte verloren',
    cardPairSuccess: 'Erfolgreich mit der Karte verbunden',
    cardPairFail: 'Wir konnten die Karte nicht verbinden',
    feedbackSuccess: 'Danke für Dein Feedback',
    feedbackFail: 'Feedback konnte nicht gesendet werden.',
    runFileResponse: 'Antwort der ausgeführten Datei. Klicke hier um mehr zu sehen',
    runFileError: 'Programm konnte nicht ausgeführt werden',
    runFileSuccess: 'Programm erfolgreich ausgeführt',
  },
  legacyVersionPopupTitle: 'Veraltete Version',
  legacyVersionPopupBody: 'So wie es aussieht hast Du eine veraltete Software-Version auf Deiner Oxocard. Damit Du den Editor brauchen kannst, musst Du zuerst deine Karte aktualisieren.',

  errorCode0: 'Nach \'def\' muss ein Funktionsname folgen.',
  errorCode1: 'Fehlendes Zeichen: \'(\'',
  errorCode2: 'Fehlendes Zeichen: \')\'',
  errorCode3: 'Variablen brauchen einen Datentyp. Wähle zwischen \'int\', \'char\', oder \'byte\'',
  errorCode4: 'Es gibt eine unbekannte oder fehlende Anweisung im Code.',
  errorCode5: '\'=\', \'(\' oder \'+=\' werden erwartet.',
  errorCode6: '\'++\' oder \'--\' werden erwartet.',
  errorCode7: 'Unbekanter Funktionsname. Prüfe, ob der Namen richtig geschrieben wurde.',
  errorCode8: 'Fehlendes Zeichen: \'(\'',
  errorCode9: 'Fehlendes Zeichen: \')\'',
  errorCode10: 'Hier wird eine Zahl erwartet.',
  errorCode11: 'Diese Funktion erwartet eine Liste oder eine Zeichenkette, du hast aber eine Zahl übergeben.',
  errorCode12: 'Diese Funktion erwartet keine Parameter. Du hast aber versucht, Werte zu übergeben.',
  errorCode13: 'Falsche Anzahl Parameter. Check die Dokumentation zur Funktion oder schau dir ein Beispiel an, in der die Funktion genutzt wurde.',
  errorCode14: '\']\' erwartet.',
  errorCode15: '\'return\' ist in Ereignisprozeduren nicht erlaubt. Nutze stattdessen \'exit\'.',
  errorCode16: 'Fehlendes Zeichen: \')\'',
  errorCode17: 'Diese Variable ist nicht definiert. Prüfe, ob der Namen richtig geschrieben wurde.',
  errorCode18: '\']\' erwartet, aber nicht gefunden.',
  errorCode19: 'Du musst hier eine Variabelliste verwenden.',
  errorCode20: 'Fehlendes Zeichen: \')\'',
  errorCode21: 'In diesem Ausdruck ist ein Fehler aufgetreten.',
  errorCode22: 'Fehlendes Zeichen: \')\'',
  errorCode23: 'Fehlendes Zeichen: \')\'',
  errorCode24: 'Jede Anweisung muss entweder auf einer neuen Zeile oder mit Strichpunkt (\';\') abgetrennt werden.',
  errorCode25: 'Globalen Variablen kann man hier keinen Wert zuweisen (nur in Funktionen erlaubt)',
  errorCode26: 'Hier braucht es einen Doppelpunkt \':\' mit eingerückten Anweisungen.',
  errorCode27: 'Fehler in der for-Anweisung: for variable in liste: anweisungen',
  errorCode28: 'Nach \'for\' darf nur eine einfache Variable folgen, kein Liste',
  errorCode29: '\'in\' erwartet.',
  errorCode30: 'Ein indizierter Zugriff mit [] erwartet eine vorgaengig deklarierte Variable.',
  errorCode31: 'Bei for ... in .. muss eine Liste, eine Integer-Variable oder eine Zahl folgen.',
  errorCode32: 'Listen-Typen sind hier nicht erlaubt.',
  errorCode33: 'Hier fehlt ein \'=\'.',
  errorCode34: 'Dieser Variablen-Namen ist bereits in Verwendung.',
  errorCode35: 'Globale nummerische Variablen können nur mit 0 initialisiert werden.',
  errorCode36: 'Globale Listen-Variablen koennen nur mit [] initialisiert werden.',
  errorCode37: 'Hier muss eine def-Anweisung oder die Deklaration einer globalen Variablen stehen.',
  errorCode38: 'Komma erwartet.',
  errorCode39: 'Nach einem Doppelpunkt müssen die Zeilen eingerückt sein.',
};
